import { ServiceOrderDetailModel } from '@/domain/models'
import { GetServiceOrderDetailParams, GetServiceOrderDetail } from '@/domain/usecases'
import { HttpClient, HttpRequest, HttpStatusCode } from '@/data/protocols'
import { AccessDeniedError, UnexpectedError, UnexpectedResultFormatError } from '@/domain/errors'

export class RemoteGetServiceOrderDetail implements GetServiceOrderDetail {
  constructor (
    private readonly url: string,
    private readonly httpClient: HttpClient<ServiceOrderDetailModel>
  ) {}

  async getDetail (params: GetServiceOrderDetailParams): Promise<ServiceOrderDetailModel> {
    const request: HttpRequest = {
      url: `${this.url}/api/portal/dados-os`,
      method: 'get',
      params
    }

    const { statusCode, body } = await this.httpClient.request(request)

    switch (statusCode) {
      case HttpStatusCode.ok:
        if (!body) {
          throw new UnexpectedResultFormatError()
        }

        return body
      case HttpStatusCode.unauthorized: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}
